import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { Field } from 'react-final-form';

type TextFormFieldProps = {
  name: string;
  label?: string;
  type?: string;
  validate?: (value: any) => string | undefined;
  parse?: (value: any) => any;
  format?: (value: any) => any;
} & TextFieldProps;

const TextFormField: React.FC<TextFormFieldProps> = ({
  name,
  label,
  type = 'text',
  validate,
  parse,
  format,
  ...rest
}) => {
  return (
    <Field name={name} validate={validate} parse={parse} format={format}>
      {({ input, meta }) => (
        <TextField
          {...rest}
          {...input}
          type={type}
          label={label}
          fullWidth
          error={meta.touched && meta.error ? true : false}
          helperText={meta.touched && meta.error ? meta.error : ''}
        />
      )}
    </Field>
  );
};

export default TextFormField;
